import React, { useEffect, useMemo, useState } from "react";
import { Global } from "../helpers/Global";

// ✅ Toast global
import { useToast } from "../hooks/useToast";

// ===== MUI =====
import { Box, Paper, Typography, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export const JornadasProcesoAdmin = () => {
  const toast = useToast();

  const [jornadas, setJornadas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cargarDatos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const [resJornadas, resUsuarios] = await Promise.all([
        fetch(`${Global.url}jornadas/proceso`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
        fetch(`${Global.url}usuarios`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }),
      ]);

      if (!resJornadas.ok) {
        toast.error("No se pudieron obtener las jornadas en proceso.");
        setJornadas([]);
      } else {
        const data = await resJornadas.json();
        setJornadas(Array.isArray(data) ? data : []);
      }

      if (!resUsuarios.ok) {
        toast.warning("No se pudieron cargar los usuarios (se mostrarán IDs).");
        setUsuarios([]);
      } else {
        const data = await resUsuarios.json();
        setUsuarios(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      console.error("Error al cargar las jornadas:", error);
      toast.error("Error de conexión con el servidor.");
      setJornadas([]);
      setUsuarios([]);
    } finally {
      setLoading(false);
    }
  };

  // Utilidad para obtener nombre completo
  const getNombreCompleto = (usuario_id) => {
    const u = usuarios.find((x) => String(x.id) === String(usuario_id));
    return u ? `${u.nombre} ${u.apellidos || ""}`.trim() : `ID ${usuario_id ?? "-"}`;
  };

  const fmtDate = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const rows = useMemo(
    () =>
      (jornadas || []).map((j) => ({
        ...j,
        usuario_nombre: getNombreCompleto(j.usuario_id),
        gerente_nombre: getNombreCompleto(j.gerente_id),
        inicio_txt: fmtDate(j.fecha_inicio),
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [jornadas, usuarios]
  );

  const columns = useMemo(
    () => [
      { field: "usuario_nombre", headerName: "Usuario", flex: 1, minWidth: 220 },
      { field: "centro", headerName: "Centro", flex: 1, minWidth: 220 },
      { field: "inicio_txt", headerName: "Inicio", minWidth: 180 },
      { field: "gerente_nombre", headerName: "Gerente", flex: 1, minWidth: 220 },
    ],
    []
  );

  return (
    <Box className="appContainer appContainer--wide">
      <Stack spacing={2}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>
          Jornadas en Proceso
        </Typography>

        <Paper sx={{ height: 640, p: 1 }}>
            <DataGrid
                rows={rows}
                columns={columns}
                getRowId={(row) => row.id}
                disableRowSelectionOnClick
                loading={loading}
                pagination
                initialState={{
                    pagination: { paginationModel: { page: 0, pageSize: 25 } },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                sx={{
                    "& .MuiDataGrid-columnHeaders": {
                    borderBottom: "1px solid rgba(0,0,0,0.08)",
                    },
                    "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                    },
                }}
                slots={{
                    noRowsOverlay: () => (
                    <Box sx={{ p: 2, color: "text.secondary" }}>
                        {loading ? "Cargando…" : "No hay jornadas activas actualmente."}
                    </Box>
                    ),
                }}
            />

        </Paper>
      </Stack>
    </Box>
  );
};
